import { RowTypeKey } from './Entities';

export abstract class BaseRow {
  abstract readonly _type: RowTypeKey;
}
